
import React from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { motion } from 'framer-motion';

interface SidebarSearchProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  onSearchFocus: () => void;
  searchInputRef: React.RefObject<HTMLInputElement>;
}

export const SidebarSearch: React.FC<SidebarSearchProps> = ({
  searchQuery,
  onSearchChange,
  onSearchFocus,
  searchInputRef
}) => {
  return (
    <div className="relative">
      <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
      <Input
        ref={searchInputRef}
        placeholder="Search conversations..."
        className="pl-8 bg-background/30 border-white/10 focus:border-white/30 transition-all focus:ring-white/20"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        onFocus={onSearchFocus}
      />
    </div>
  );
};
